export default "/static/build/your-life.webp";